import { Navigate } from "react-router"

export function CallbackPage() {
  return <Navigate to="/" />
}
